if (!customElements.get('sticky-atc')) {
    customElements.define(
        'sticky-atc',
        class StickyAtc extends HTMLElement {
            observer;
            boundQuantityChange;
            boundVariantChange;
            priceElement;
            priceFormatter;
            price;

            constructor() {
                super();
                this.priceElement = this.querySelector(".sticky__meta");
                if (this.priceElement) {
                    this.price = this.extractPrice(this.priceElement.textContent);
                    this.boundQuantityChange = this.observerQuantityChange.bind(this);
                    this.boundVariantChange = this.onVariantChange.bind(this);
                    this.priceFormatter = new Intl.NumberFormat(Shopify.locale + "-" + Shopify.country,
                        {
                            style: 'decimal',
                            currency: Shopify.currency.active,
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        });

                }
            }

            extractPrice(price) {
                return parseFloat(price.replace(/[^0-9.-]+/g, ""));
            }

            onVariantChange() {
                this.priceElement.textContent = this.getFormattedPrice(this.price);
            }

            getFormattedPrice(price) {
                return window.moneyWithCurrencyFormat
                    .replace("{{amount}}", this.priceFormatter.format(price))
                    .replace(Shopify.currency.active, "")
                    .trim();
            }

            observerQuantityChange(e) {
                if (e.target.tagName === 'INPUT' && e.target.name === 'quantity') {
                    const value = parseInt(e.target.value);
                    const newPrice = this.price * value;
                    this.priceElement.textContent = this.getFormattedPrice(newPrice);
                }
            }

            initObserver() {
                const buyBox = this.closest('product-info')?.querySelector('.product-form__submit');
                if (!buyBox || !('IntersectionObserver' in window)) return;
                this.observer = new IntersectionObserver(
                    (entries) => {
                        // records arrive oldest-first — the last one is current state
                        const entry = entries[entries.length - 1];
                        const passed = !entry.isIntersecting;
                        // && entry.boundingClientRect.bottom < 0;
                        this.classList.toggle('is-visible', passed);
                        if (passed) document.documentElement.style.setProperty('--sticky-atc-height', `${this.offsetHeight}px`);
                        document.documentElement.classList.toggle('sticky-atc-visible', passed);
                    },
                    {threshold: 0}
                );
                this.observer.observe(buyBox);
            }

            connectedCallback() {
                this.initObserver();
                window.addEventListener('change', this.boundQuantityChange);
                window.addEventListener('variantChange', this.boundVariantChange);
            }

            disconnectedCallback() {
                this.observer?.disconnect();
                window.removeEventListener('change', this.boundQuantityChange);
                window.removeEventListener('variantChange', this.boundVariantChange);
            }
        }
    );
}
